import { inject, observer } from "mobx-react";
import { Card } from "primereact/card";
import { RadioButton } from "primereact/radiobutton";
import { Sidebar } from "primereact/sidebar";
import { TabMenu } from "primereact/tabmenu";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FIX from "./FIX";
import RatesTableComponent from "./RatesTableComponent";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const RatesTraffic = inject("mainStore")(
    observer(({ mainStore, apiUrl, value }) => {
        const { secondParam } = useParams();
        const [rates, setRates] = useState([{ ...defaultRates, siteId: secondParam }]);
        const [ratesData, setRatesData] = useState([]);
        const [tab, setTab] = useState({ idx: 0, key: "cpc" });
        const [visible, setVisible] = useState(false);
        const [rateSelect, setRateSelect] = useState({ cpc: [], cpm: [], fix: [] });
        const [disabledSave, setDisabledSave] = useState(false);

        const ratesDataFilter = ratesDataFilterFunc(ratesData, secondParam) || {};
        const isSelectLenght = ratesDataFilter.cpc.concat(ratesDataFilter.cpm).length;

        const tabItemsDisable = tabItems.map((el, idx) => {
            if (ratesDataFilter[el.key].length) {
                return { ...el, idx };
            } else {
                return { ...el, idx, disabled: true };
            }
        });

        const tabActiveDefault = tabItemsDisable.find((f) => !f.disabled) || { key: "cpc", idx: 0 };

        useEffect(() => {
            getRates(apiUrl + `&filters[siteId]=${secondParam}`);
        }, []);

        useEffect(() => {
            if (isSelectLenght === 1) {
                setRateSelect(ratesDataFilter);
            } else if (ratesData.length > 0) {
                const rateOfferIds = secondParam;
                const newRates = ratesDataFilterFunc(ratesData, rateOfferIds);
                setRateSelect(newRates);
            }

            setTab(tabActiveDefault);
        }, [ratesData, value, isSelectLenght]);

        const getRates = async (apiUrl) => {
            const resp = await mainStore.getByUrl(apiUrl, false, "", false, true);
            if (resp && resp.success) {
                setRatesData(resp.data);
            }
        };

        useEffect(() => {
            const val = validKeys(rates, validRates) || false;
            setDisabledSave(val);
        }, [rates]);

        const handleAddRates = () => {
            setRates((prev) => prev.concat({ ...defaultRates, siteId: secondParam }));
        };

        const handleDelete = (idx) => {
            const arr = rates.filter((el, index) => index !== idx);
            setRates(arr);
        };

        const handleChange = (e, key) => {
            setRates(rates.map((rate, index) => (index === key ? { ...rate, type: e.value } : rate)));
        };

        const handleUpdata = (index, updatedRate) => {
            const newRates = [...rates];
            newRates[index] = updatedRate;
            setRates(newRates);
        };

        const handleSave = async () => {
            const resp = await mainStore.postByUrl(`/promo/siterates`, { ratesArray: rates });
            if (resp && resp.success) {
                const rateId = resp.data.map((i) => i.data._id);
                mainStore.setMainStore(`detailData.rateIds`, (Array.isArray(value) ? value : []).concat(rateId));
                setVisible(false);
                setRates([{ ...defaultRates, siteId: secondParam }]);
                getRates(apiUrl);
            }
        };

        const onTabChange = (e) => {
            setTab({ idx: e.index, key: e.value.key });
        };

        const handleRemoveItem = async (id) => {
            let resp = await mainStore.deleteByUrl(`/promo/rates/${id}`);
            if (resp && resp.success) {
                getRates(apiUrl);
            }
        };

        return (
            <div className="rates-traffic">
                <Sidebar className="rates-traffic__sidebar" visible={visible} position="right" onHide={() => setVisible(false)}>
                    <Card title="Ставки">
                        {rates.map((item, key) => {
                            return (
                                <div className="block" key={key}>
                                    <div className="radio__container">
                                        <label>Тип оплаты*</label>
                                        <div className="radio__block">
                                            {radioButton.map((i, idx) => (
                                                <div className="radio__item" key={idx}>
                                                    <RadioButton value={i.value} onChange={(e) => handleChange(e, key)} checked={item.type === i.value} />
                                                    <label>{i.label}</label>
                                                </div>
                                            ))}
                                        </div>
                                        {rates.length > 1 ? <ButtonUI icon="pi pi-trash" rounded text severity="danger" className="btn_delete" onClick={() => handleDelete(key)} /> : null}
                                    </div>

                                    <FIX item={item} handleUpdata={handleUpdata} index={key} />
                                </div>
                            );
                        })}
                        <div className="group__button">
                            <ButtonUI label={"Добавить новый тип оплаты"} icon="pi pi-plus" outlined onClick={handleAddRates} />
                            <ButtonUI label={"Сохранить тип плейсмента"} severity="success" onClick={handleSave} disabled={disabledSave} />
                        </div>
                    </Card>
                </Sidebar>

                {rateSelect[tab.key]?.length ? (
                    <div className="rates__company">
                        <div className="rates__list">
                            <div className="list__block">
                                <div>
                                    <TabMenu model={tabItemsDisable} activeIndex={!tab ? tabActiveDefault.idx : tab.idx} onTabChange={onTabChange} />
                                </div>
                                <RatesTableComponent items={rateSelect[tab.key]} tab={!tab ? tabActiveDefault.key : tab.key} handleRemoveItem={handleRemoveItem} />
                            </div>
                        </div>
                    </div>
                ) : null}

                <ButtonUI className="button__rate" label={"Добавить тип оплаты"} icon="pi pi-plus-circle" outlined onClick={() => setVisible(!visible)} style={{ width: "100%" }} />
            </div>
        );
    }),
);

const ratesDataFilterFunc = (ratesData, value) =>
    ratesData
        .filter((el) => el.siteId === value)
        .reverse()
        .reduce(
            (acc, row) => {
                acc[row.type]?.push(row);
                return acc;
            },
            { cpc: [], cpm: [], fix: [] },
        );

const tabItems = [
    { label: "CPC", key: "cpc" },
    { label: "CPM", key: "cpm" },
    { label: "FIX", key: "fix" },
];

const radioButton = [
    { label: "CPC", value: "cpc" },
    { label: "CPM", value: "cpm" },
    { label: "Fix", value: "fix" },
];

const defaultRates = {
    nds: 0, //Ставка НДС
    type: "cpc", //Тип ставки cpo||cpl
    // cpoType: 'rubPerOrder', //Тип ставки rubPerOrder||rateGradatrion||percentAmount
    priceWithNds: null,
    // rateGradationArray: [{ from: null, to: null, rate: null }],
    // percentAmount: null,
    comments: "",
    indefinitely: false, //Бессрочно
    dateStart: null, //Дата начала действия ставки
    dateEnd: null, //Дата окончания действия ставки
    siteId: null,
};

let validRates = { comments: "", dateEnd: null, dateStart: null, priceWithNds: null };

const validKeys = (arr, validKeysObj) => {
    const clearKeys = (type) => {
        const obj = Object.assign({}, validKeysObj);
        switch (type) {
            case "rubPerOrder":
                delete obj.percentAmount;
                delete obj.rateGradationArray;
                break;
            case "rateGradation":
                delete obj.percentAmount;
                delete obj.priceWithNds;
                break;
            case "percentAmount":
                delete obj.rateGradationArray;
                delete obj.priceWithNds;
                break;

            default:
                break;
        }

        return obj;
    };

    let isNotValid = true;

    for (let i = 0; i < arr.length; i++) {
        const el = arr[i];
        const objValid = clearKeys(el.cpoType);
        if (el.indefinitely) delete objValid.dateEnd;

        const validKey = Object.entries(objValid).some(([key, val]) => {
            if (Array.isArray(el[key])) {
                return validKeys(el[key], val);
            } else {
                return el[key] == val;
            }
        });

        isNotValid = validKey;
        if (validKey) break;
    }

    return isNotValid;
};

export default RatesTraffic;
